'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

const PIXEL_ID = '1425331596300815'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: Fbq
  loaded: boolean
  version: string
}

type FbqWindow = Window & { fbq?: Fbq; _fbq?: Fbq }

/** Standard Meta Pixel bootstrap: queues calls until fbevents.js loads. */
function initPixel(): Fbq {
  const w = window as FbqWindow
  if (w.fbq) return w.fbq

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args)
    else fbq.queue.push(args)
  } as Fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  w.fbq = fbq
  w._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  fbq('init', PIXEL_ID)
  return fbq
}

export function MetaPixel() {
  const [consented, setConsented] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    if (localStorage.getItem('cookie_consent') === 'accepted') {
      setConsented(true)
    }

    const handler = () => setConsented(true)
    window.addEventListener('cookie_consent_accepted', handler)
    return () => window.removeEventListener('cookie_consent_accepted', handler)
  }, [])

  useEffect(() => {
    if (!consented) return
    const fbq = initPixel()
    fbq('track', 'PageView')
    if (pathname.endsWith('/offer-booked')) fbq('track', 'Lead')
  }, [consented, pathname])

  return null
}
